import MagnifyIcon from "mdi-react/MagnifyIcon";
import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import useDebounce from "../../utils/hooks";
import "./../../assets/scss/scoped/items-table.scoped.scss";
import queryString from "query-string";
import ReactPaginate from "react-paginate";
import { paginationOptions, fetchActionsUtil } from "../../utils/helpers";
import { toast } from "react-toastify";

export default function DriverSelectorTable({
  handleSelectedItem,
  url = "api/fleet/drivers",
  status = "active",
}) {
  const { backendUrl } = useAuth();
  const [queryParams, setQueryParams] = useState({
    page: 1,
    limit: 100,
    q: "",
    status,
  });

  const debouncedqueryParams = useDebounce(queryParams, 500);

  const { data } = useQuery(
    ["DRIVER_SELECTOR_TABLE", { debouncedqueryParams }],
    () =>
      fetchActionsUtil(
        `${backendUrl}/${url}?${queryString.stringify(queryParams)}`,
        "GET"
      ),
    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  return (
    <div className="items-table-area rounded">
      <div className="search-area m-3">
        <MagnifyIcon />
        <input
          className="form-control search-input"
          name="q"
          value={queryParams.q}
          onChange={(e) =>
            setQueryParams({
              ...queryParams,
              page: 1,
              [e.target.name]: e.target.value,
            })
          }
          placeholder="Search driver..."
          autoFocus
          autoComplete="off"
          type={"text"}
        />
      </div>

      <div className="content">
        <Table borderless hover striped className="product-table">
          <thead className="sticky text-nowrap">
            <tr>
              <th scope="col">Employee ID</th>
              <th scope="col">Name</th>
              <th scope="col">License Number</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.drivers &&
              data?.data?.drivers.map((el, index) => (
                <tr
                  className="p-cursor"
                  key={index}
                  style={
                    !el.licenseNumber
                      ? {
                          opacity: 0.8,
                        }
                      : {}
                  }
                  onClick={() => {
                    if (!el.licenseNumber)
                      return toast.warn("Complete driver profile");
                    handleSelectedItem && handleSelectedItem(el);
                  }}
                >
                  <td>{el.employee_id}</td>
                  <td>{el.Name}</td>
                  <td>{el.licenseNumber}</td>
                  <td>{el.status}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>

      <div className="d-flex justify-content-between px-3 my-3 align-items-center pagination">
        <p className="m-0">
          Showing {data?.data?.startIndex + 1} to{" "}
          {data?.data?.endIndex <= data?.data?.count
            ? data?.data?.endIndex
            : data?.data?.count}{" "}
          of {data?.data.count} entries
        </p>

        <ReactPaginate
          {...paginationOptions}
          pageCount={Math.ceil(data?.data.count / queryParams.limit)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={0}
          onPageChange={({ selected }) => {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            setQueryParams({
              ...queryParams,
              page: selected + 1,
            });
          }}
          forcePage={queryParams.page - 1}
        />
      </div>
    </div>
  );
}
